import { PartnerProductSummary } from 'common/types/responses'
import { BillingPeriod } from 'common/types/enums'
import money from 'common/utils/number/money'

export default function (product: PartnerProductSummary) {
  if (!product) {
    return null
  }
  return `${money(product.cost)} per ${
    product.billing_period === BillingPeriod.MONTHLY ? 'month' : 'year'
  }`
}
